import { PROTOTYPE_STENCIL_SLUG, FRAMELESS_STENCIL_SLUG, FRAMED_STENCIL_SLUG } from "../data/StencilsConstants"

const global_stencils_rules = {
  panelize: 'required',
  print_confirmation: 'required',
}

const prototype_validation_rules = {
  prototype_stencil_type: 'required',
  aperture_count: 'required',
  flaps: 'required',
  alignment: 'required',
  stencil_length: 'required',
  stencil_width: 'required',
  stencil_thickness: 'required',
  fiducial_data: 'required',
}

const frameless_validation_rules = {
  foil_type: 'required',
  aperture_count: 'required',
  manual_printing: 'required',
  stencil_size: 'required',
  frame_type: 'required',
  printer_type: 'required',
  stencil_thickness: 'required',
  fiducial_data: 'required',
}

const framed_validation_rules = {
  frame_size: 'required',
  aperture_count: 'required',
  stencil_thickness: 'required',
  fiducial_data: 'required',
  printer_type: 'required',
}

export const getValidationRules = (stencilsType) => {
  switch (stencilsType) {
    case PROTOTYPE_STENCIL_SLUG:
      return prototype_validation_rules;
    case FRAMELESS_STENCIL_SLUG:
      return frameless_validation_rules;
    case FRAMED_STENCIL_SLUG:
      return framed_validation_rules;
    default:
      return {};
  }
}

export const buildValidationParameters = (stencilsType, parameters) => {
  const rules = getValidationRules(stencilsType);
  const validationParameters = {};

  Object.keys(rules).forEach((key) => {
    validationParameters[key] = {
      rule: rules[key],
      value: parameters[key],
    }
  });

  return validationParameters;
}

export const buildGlobalValidationParameters = (parameters) => {
  const validationParameters = {};

  Object.keys(global_stencils_rules).forEach((key) => {
    validationParameters[key] = {
      rule: global_stencils_rules[key],
      value: parameters[key],
    }
  });

  return validationParameters;
}